SupportViewVoucherServiceActionView = require('./view_voucher_service_action')
SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View')
SupportServiceActionsBaseView = require('./service_action_base')
SupportUtilsHelper = require('../../../helpers/utils')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportPrintGiftCardVoucherServiceActionView extends SupportServiceActionsBaseView

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)
    if @order.groupons.length == 1
      @addHref @getUrlForVoucher @order.groupons[0]

  toHash: ->
    hash =
      service_action_id : "print_gift_card_voucher"

    if @isSingleGroupon()
       hash.service_action = I18n.t("js.modules.support.print_gift_card_voucher")
       @extendSingleGrouponParams(hash)
    else
      hash.service_action = I18n.t("js.modules.support.print_gift_card_vouchers")
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder
    if @order.groupons.length > 1
      args =
        orders: @order
        serviceActionName: 'print_gift_card_voucher'
        singleActionButtonCallback: @getUrlForVoucher
        groupActionButtonCallback: @getUrlForAllVouchers
        showgroupActionButton: false
        title: I18n.t("js.modules.support.print_gift_card_vouchers")
        singleActionButtonName: I18n.t("js.modules.support.print_gift_card_voucher")
      multipleQtyPopup = new SupportMultipleQtyPopupView(args)
      multipleQtyPopup.render()

    return true

  getUrlForAllVouchers:(order_id)->
    null

  getUrlForVoucher: (groupon) ->
    if SupportUtilsHelper.isCurrentOrderGoodsDeal()
      order = Groupon.Support.currentOrder
      "/deals/#{order.deal?.id}/gift/#{order.dealOption?.id}.pdf"
    else
      "/mygroupons/gifts/envelope/voucher/#{ currentUser.id }/#{groupon.id}.pdf"

  addHref : (url) ->
    @$el.find('#print_gift_card_voucher').attr('href', url)

  renderErrorPage: ->
    flash('error', "Error when contacting server for Voucher PDF")

  events :
    "click #print_gift_card_voucher"  : "actionHandler"

module.exports = SupportPrintGiftCardVoucherServiceActionView
